module.exports = __webpack_public_path__ + "img/atari1200_page11.dca31d53.jpg";